import * as React from 'react';

import { DataLake } from '@graylog/enterprise-api';

import RetrievalContext from 'data-lake/preview/contexts/RetrievalContext';
import type { DataLakeActionValues } from 'data-lake/Types';
import { EXTERNAL_DATA_LAKE_TYPE } from 'data-lake/Constants';
import type { SelectableLogViewMessage } from 'logview/types';

const bulkRetrievePayload = (
  messages: SelectableLogViewMessage[],
  dataLakeId: string,
  payload: { sourceId: string },
) => ({
  messages,
  data_lake_id: dataLakeId,
  type: EXTERNAL_DATA_LAKE_TYPE,
  table: payload.sourceId,
  timeout: undefined,
});

const onRetrieveMessages = (
  { data_lake_id, stream_ids, field_filters, operator }: DataLakeActionValues,
  from: string,
  to: string,
) => {
  const request: {
    data_lake_id: string;
    type: string;
    table: string;
    field_filters: {
      value: Object;
      field_name: string;
    }[];
    operator: 'AND' | 'OR';
  } = {
    data_lake_id,
    type: EXTERNAL_DATA_LAKE_TYPE,
    table: stream_ids[0],
    field_filters,
    operator,
  };

  return DataLake.retrieveBulkRetrievalRequest(request, from, to);
};

const RetrievalProvider = ({ children }: React.PropsWithChildren) => {
  const contextValue = React.useMemo(() => ({ bulkRetrievePayload, onRetrieveMessages }), []);

  return <RetrievalContext.Provider value={contextValue}>{children}</RetrievalContext.Provider>;
};

export default RetrievalProvider;
